import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';

const normalizePath = (path) => path.replace(/\/$/, '');

const isRouteMatch = (currentPath, routePath) => {
    const normalizedCurrent = normalizePath(currentPath);
    const normalizedRoute = normalizePath(routePath);

    if (normalizedRoute.includes(':id')) {
        const routePattern = normalizedRoute.replace(':id', '[^/]+');
        const regex = new RegExp(`^${routePattern}$`);
        return regex.test(normalizedCurrent);
    }

    return normalizedCurrent === normalizedRoute ||
        (normalizedRoute !== '' && normalizedCurrent.startsWith(normalizedRoute + '/'));
};

// Same pill as the main sidebar's MenuBadge (components/Sidebar.jsx), reused
// here so a sub-item (e.g. Subscribers, Cancellation Requests) can show its
// own live count.
const SubSidebarBadge = ({ count }) => {
    if (!count) return null;
    return <span className="menu-badge">{count > 99 ? '99+' : count}</span>;
};

const SubSidebar = ({ activeSubMenu, subMenus, counts = {} }) => {
    const location = useLocation();

    if (!activeSubMenu || !subMenus[activeSubMenu]) return null;

    const subMenu = subMenus[activeSubMenu];

    const getResolvedPath = (path) => path;

    return (
        <div className="sub-sidebar">
            <div className="sub-sidebar-menu">
                {subMenu.items.map((item, index) => {
                    const resolvedPath = getResolvedPath(item.path);
                    const isActive = isRouteMatch(location.pathname, resolvedPath);
                    return (
                        <NavLink
                            key={index}
                            to={resolvedPath}
                            className={`sub-sidebar-link ${isActive ? 'active' : ''}`}
                        >
                            <span className="sub-sidebar-icon">
                                <i className={item.icon}></i>
                            </span>
                            <span className="sub-sidebar-title">{item.title}</span>
                            {item.countKey && <SubSidebarBadge count={counts[item.countKey]} />}
                        </NavLink>
                    );
                })}
            </div>
        </div>
    );
};

export default SubSidebar;
